<div class="loader" ngClass="{{ size }}"></div>
